import React from 'react';
// import {HtmlParse} from 'utils';
// import Warning from 'images/icons/warning.svg';
import PropTypes from 'prop-types';
import style from './style.scss';//NOSONAR

const NewFeature = ({close}) => {

    return <div className="new-feature new-modal-container">

        <div className="new-modal-scroll">
            <div className="icon-wrap-notification">
                <i className="order-user-address-icn jumbo-icon-new-alert"></i>
            </div>
            <span className="new-feature-text">Ahora podrás <strong>anular tus pedidos desde Mis compras.</strong> Lo podrás hacer únicamente cuando tu pedido esté en estado Ingresado.</span>
        </div>

        <div className="modal-actions">
            <button className="primary-btn" onClick={close}>Entendido</button>
        </div>
        
    </div>;
}
NewFeature.propTypes = {
    close: PropTypes.func
};
export default NewFeature;
